// core/data/notifications.ts — typed seed for the notifications feed.
//
// Faithfully ported from legacy src/scripts/data/notifications.js.
// Social notifications embed actor display fields inline.
// Council notifications have no personal actor; they carry kind/team/body.
// postIds reference existing posts (post-001..post-004).

import type { Notification } from '@/core/models/notification';

export const seedNotifications: Notification[] = [
  {
    id: 'n-01',
    type: 'like',
    actor: { name: 'TruthWarrior',  handle: '@TruthWarrior',  av: 'av-4', verified: true },
    postId: 'post-004',
    snippet: "Freedom isn't just a right…",
    time: '2h',
    read: false,
    fromFollowed: true,
  },
  {
    id: 'n-02',
    type: 'reply',
    actor: { name: 'LibertyVoice',  handle: '@LibertyVoice',  av: 'av-5', verified: true },
    postId: 'post-004',
    snippet: 'Well said. This needs to be heard.',
    time: '3h',
    read: false,
    fromFollowed: true,
  },
  {
    id: 'n-03',
    type: 'follow',
    actor: { name: 'WokeFlies', handle: '@WokeFlies', av: 'av-1', verified: false },
    postId: null,
    time: '4h',
    read: true,
    fromFollowed: false,
  },
  {
    id: 'n-04',
    type: 'cherish',
    actor: { name: 'OpenMind', handle: '@OpenMindX', av: 'av-3', verified: true },
    postId: 'post-004',
    snippet: 'Cherished for the bold take.',
    time: '5h',
    read: true,
    fromFollowed: true,
  },
  {
    id: 'n-05',
    type: 'spread',
    actor: { name: 'FreeThinker', handle: '@FreeThinker', av: 'av-4', verified: true },
    postId: 'post-004',
    time: '6h',
    read: true,
    fromFollowed: true,
  },
  {
    id: 'n-06',
    type: 'mention',
    actor: { name: 'SeenAndUnseen', handle: '@SeenUnseen', av: 'av-2', verified: false },
    postId: 'post-002',
    snippet: '@WayneTech what do you think?',
    time: '7h',
    read: true,
    fromFollowed: false,
  },
  {
    id: 'n-07',
    type: 'like',
    actor: { name: 'FreedomSeeker', handle: '@FreedomSeeker', av: 'av-1', verified: true },
    postId: 'post-001',
    time: '9h',
    read: true,
    fromFollowed: false,
  },
  {
    id: 'n-08',
    type: 'reply',
    actor: { name: 'LibertyMind', handle: '@LibertyMind', av: 'av-2', verified: true },
    postId: 'post-002',
    snippet: 'Decentralization is the way.',
    time: '11h',
    read: true,
    fromFollowed: true,
  },
  {
    id: 'n-09',
    type: 'council',
    kind: 'under-review',
    team: 'Team Alpha',
    postId: 'post-004',
    body: 'Your post is under review by Team Alpha.',
    time: '12h',
    read: false,
  },
  {
    id: 'n-10',
    type: 'council',
    kind: 'cleared',
    team: 'Team Horizon',
    postId: 'post-004',
    body: 'Team Horizon reviewed your post and cleared it. No action taken.',
    time: '1d',
    read: true,
  },
  {
    id: 'n-11',
    type: 'follow',
    actor: { name: 'OpenDialogue', handle: '@OpenDialogue', av: 'av-3', verified: false },
    postId: null,
    time: '1d',
    read: true,
    fromFollowed: false,
  },
  {
    id: 'n-12',
    type: 'council',
    kind: 'appeal',
    team: 'Team Vanguard',
    postId: null,
    body: 'Your appeal was reviewed by Team Vanguard and upheld.',
    time: '2d',
    read: true,
  },
];
